<div class="w-100">
  <mwp-card-content-header [url]="apiUrl" />
  <div class="row">
    @if (showMiscTable) {
      <div class="col-4 mb-3">
        <div class="content-container">
          <div class="row h-100">
            <div class="col-12">
              <div class="title">
                <mwp-text-translate text="Miscellaneous Deductions" jsonKey="miscellaneousDeductions" />
              </div>
              <div class="content">
                <mwp-table [tableColumns]="miscellaneousDeductionsColumns" [dataSource]="miscellaneousDeductionsMatTableData" />
              </div>
            </div>
            <div class="footer mt-auto">
              <div class="message-container blue-fill d-flex justify-content-between">
                <div>
                  <mwp-text-translate text="Total Miscellaneous Deductions" jsonKey="totalMiscellaneousDeductions" />
                </div>
                <div>
                  <span>{{deductions.miscTotalAmount | currency}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    @if (showWageTable) {
      <div class="col-4 mb-3">
        <div class="content-container h-100">
          <div class="row h-100">
            <div class="col-12">
              <div class="title">
                <mwp-text-translate text="Wage Attachments" jsonKey="wageAttachments" />
              </div>
              <div class="content">
                <mwp-table [tableColumns]="wageAttachmentsDeductionsColumns" [dataSource]="wageAttachmentsMatTableData" />
              </div>
            </div>
            <div class="footer col-12 mt-auto">
              <div class="message-container blue-fill d-flex justify-content-between">
                <div>
                  <mwp-text-translate text="Total Wage Attachments" jsonKey="totalWageAttachmentsDeductions" />
                </div>
                <div>
                  <span>{{deductions.wageAttachmentsTotalAmount | currency}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    @if (showBenefitTable) {
      <div class="col-4 mb-3">
        <div class="content-container">
          <div class="row h-100">
            <div class="col-12">
              <div class="title">
                <mwp-text-translate text="Benefit Deductions" jsonKey="benefitDeductions" />
              </div>
              <div class="content">
                <mwp-table [tableColumns]="benefitDeductionsColumns" [dataSource]="benefitDeductionsMatTableData" />
              </div>
            </div>
            <div class="footer col-12 mt-auto">
              <div class="message-container blue-fill d-flex justify-content-between">
                <div>
                  <mwp-text-translate text="Total Benefit Deductions" jsonKey="totalBenefitDeductions" />
                </div>
                <div>
                  <span>{{deductions.benefitTotalAmount | currency}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }

    @if (showArrearsTable) {
      <div class="col-4 mb-3">
        <div class="content-container">
          <div class="row h-100">
            <div class="col-12">
              <div class="title">
                <mwp-text-translate text="Arrears" jsonKey="arrears" />
              </div>
              <div class="content">
                <mwp-table [tableColumns]="arrearsColumns" [dataSource]="arrearsMatTableData" />
              </div>
            </div>
            <div class="footer">
              <div class="message-container blue-fill d-flex justify-content-between">
                <div>
                  <mwp-text-translate text="Total Arrears" jsonKey="totalArrears" />
                </div>
                <div>
                  <span>{{deductions.arrearsTotalAmount | currency}}</span>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    }
    @if (!showMiscTable && !showWageTable && !showBenefitTable && !showArrearsTable) {
      <div class="col-12">
        <div class="message-container blue-fill text-centered mb-4">
          <mwp-text-translate text="No Deductions" jsonKey="noDeductions" />
        </div>
      </div>
    }
  </div>
</div>